export default class Component {
  constructor (elem, theme, options, ctx) {
    this._theme = theme
    this._elem = elem
    this._ctx = ctx
    this._options = options
  }
}